import type { NavigationData } from '~/types'

export const useNavigationData = () => {
  const { locale } = useI18n()
  const navigationData = useState<NavigationData | null>('navigation-data', () => null)

  const fetchNavigationData = async () => {
    if (navigationData.value) {
      return navigationData.value
    }

    try {
      const data = await $fetch('/api/v3/core_data/navigation')
      navigationData.value = data[locale.value]
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('[ERROR] Fetching Navigation data', e)
    }

    return navigationData.value
  }

  return {
    fetchNavigationData
  }
}
